import { mods, theme } from '@approvalmax/theme';
import { StyledMods } from '@styled-kit/mods';
import styled from 'styled-components';

import { Box } from '../../../Box/Box';
import { containerWidth } from '../../SimpleLayout.styles';
import { SimpleLayoutProps } from '../../SimpleLayout.types';

export const BoxStyled = styled(Box)<StyledMods<Pick<SimpleLayoutProps, 'size'>>>`
    padding: 40px;
    grid-area: content;

    ${containerWidth};

    ${mods.not.size`
        /* for the sized content we expect not to have an internal scroll on the content */
        overflow-y: auto;
    `};

    ${mods.size.small`
        padding: 32px;
    `};

    ${mods.size.xsmall`
        padding: 32px;
    `};

    @media (max-width: ${theme.container.breakpoint.medium}) {
        padding: 24px;
    }

    @media (max-width: ${theme.container.breakpoint.xsmall}) {
        width: auto;
        padding: 8px 12px 0;
        overflow-y: initial;
    }
`;
